<template>
<div>

  <div class="header-btn">
    <el-button type="danger" @click="selectRemove">选择移除</el-button>
    <el-button @click="selectStartFlow">选择发起流程</el-button>
    <el-button @click="startFlow">全部发起流程</el-button>
    <el-button @click="exportExcel">导出模板</el-button>
    <el-button @click="importExcel">导入数据</el-button>
    <el-button type="primary" @click="exportLitigationEvidenceExcel">诉讼凭证报表</el-button>
  </div>
  <el-divider></el-divider>

  <div class="header-btn" style="margin-bottom: 5px">
    <el-badge :value="all_count" class="btn-item">
      <el-link @click="onLabelBtn()">全部</el-link>
    </el-badge>
    <template v-for="(item,index) in label_type_list">
      <el-badge :key="index" :value="item.num" class="btn-item">
        <el-link @click="onLabelBtn(item)">{{ item.name }}</el-link>
      </el-badge>
    </template>
  </div>
  <div>
    <div class="table-wrap">
      <el-table
        v-loading="loading"
        v-if="pageData" :data="pageData.list"
        border
        style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" fixed></el-table-column>
        <el-table-column
          prop="HouseName"
          label="房产" min-width="320" fixed></el-table-column>
        <el-table-column
          prop="name"
          label="业主姓名"
          width="150" fixed>
        </el-table-column>
        <el-table-column
          prop="phone"
          label="业主电话"
          width="180">
        </el-table-column>
        <el-table-column
          prop="butler_name"
          label="催费人员"
          width="100">
        </el-table-column>
        <el-table-column
          prop="账龄类型"
          label="账龄类型"
          width="90">
        </el-table-column>
        <el-table-column
          prop="type_tip"
          label="催费方式"
          width="90">
        </el-table-column>
        <el-table-column
          prop="业主诉求"
          label="业主原话"
          width="150">
        </el-table-column>
        <el-table-column
          prop="欠费类型"
          label="欠费类型"
          width="150">
        </el-table-column>
        <el-table-column
          prop="解决措施"
          label="解决措施"
          width="150">
        </el-table-column>
        <el-table-column
          prop="send_time"
          label="催费日期"
          width="100">
        </el-table-column>
        <el-table-column
          prop="上次缴费时间"
          label="上次缴费时间"
          width="150">
        </el-table-column>
        <el-table-column
          prop="第一次催费时间"
          label="第一次催费时间"
          width="150">
        </el-table-column>
        <el-table-column
          prop="第二次催费时间"
          label="第二次催费时间"
          width="150">
        </el-table-column>
        <el-table-column
          prop="第三次催费时间"
          label="第三次催费时间"
          width="150">
        </el-table-column>
        <el-table-column
          prop="created_at"
          label="添加时间"
          width="150">
        </el-table-column>
        <el-table-column
          prop="flow_status"
          label="状态"
          width="100">
        </el-table-column>
        <el-table-column
          label="	操作"
          width="180" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-view" @click="preView(scope.row)">详情</el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete-solid" @click="deleteItem(scope.row)" v-if="scope.row.flow_status==='待审核'">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-wrap">
      <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                     :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                     @current-change="pageChange"></el-pagination>
    </div>
  </div>

  <LegalHouseInfo ref="LegalHouseInfo" />

  <ViewFile ref="ViewFile" />
</div>
</template>

<script>
import Http from "../../common/Http";
import LegalHouseInfo from "../LegalHouseInfo";
import ViewFile from "../../../Common/ViewFile";
import Track from "../../../../../assets/js/trackHttp";
import {CommonHelp} from "../../common/CommonHelp";
import ButlerHttp from "../../common/ButlerHttp";

export default {
  name: "LitigationTab1",
  components: {ViewFile, LegalHouseInfo},
  inject:['where','reginWhere'],
  data(){
    return{
      label_type_list:[
        // {type:5,name:"全 部"},
        {type:5,name:"诉讼（提交）",type_ex:1},
        {type:5,name:"诉讼（诉调）",type_ex:2},
        {type:5,name:"诉讼（立案）",type_ex:3},
        // {type:10,name:"成功缴费",type_ex:5},
      ],
      pageData: {
        list: [],
        total: 0,
        pageSize: 20,
        page: 1,
      },
      all_count:0,
      loading: false,
      multipleSelection:[],
    }
  },
  mounted() {
    const that=this;
    CommonHelp.debounce(()=>{
      that.pageChange(1)
      that.getAjaxCount()
    },500,that)

  },
  methods:{
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(that.where)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;
      if(that.reginWhere.age) where.age=that.reginWhere.age;

      ButlerHttp.post("Litigation/getList", {
        ...where,
        is_task_id: 0,
        status: 2,
        page: that.pageData.page,
        page_size: that.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data;
        }
        that.loading = false;
      });
    },
    getAjaxCount(){
      const that = this;
      let where = ERP.reJson(that.where)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;
      if(that.reginWhere.age) where.age=that.reginWhere.age;
      ButlerHttp.post("Litigation/ajaxCount", {
        ...where,
        status: 2,
        is_task_id: 0
      }, res => {
        if (res.code) {
          let label_type_list = that.label_type_list;
          label_type_list = label_type_list.map(ret => {
            let item_list = res.data.filter(r => {
              if (ret.type_ex !== undefined) {
                return ret.type == r.type && ret.type_ex == r.type_ex;
              } else {
                return ret.type == r.type;
              }
            });
            ret.num = item_list.reduce((prev, cur) => prev + cur.count, 0);
            return ret;
          });
          that.label_type_list = label_type_list;
          that.type_list = res.data;
          that.all_count = res.data.filter(ret => ret.type !== 10).reduce((p, n) => p + n.count, 0);
        }
      });
    },
    pageChange(i) {
      const that=this;
      that.pageData.page = i
      that.getList()
    },
    onLabelBtn(item=null){
      this.where.type=(item||{}).type||"";
      this.where.type_ex=(item||{}).type_ex||"";
      this.pageData= {
        list: [],
        total: 0,
        pageSize: 20,
        page: 1,
      };
      this.getList()
    },
    preView(item){
      this.$refs.LegalHouseInfo.show(item)
    },
    startFlow(){
      const that = this;
      let where = ERP.reJson(that.where)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;

      ButlerHttp.post("Litigation/getBatchNumber", where, res => {
        if (res.code) {
          let timeValue = new Date().getTime();
          // ERP.navigateTo("/flow/FlowView?sheet_id=66&master_id=63&batch_number=" + res.data + '&timeValue=' + timeValue);
          ERP.navigateTo("/flow/FlowView?sheet_id=210&master_id=174&batch_number=" + res.data + '&timeValue=' + timeValue);
        } else {
          that.$message.error(res.msg || '批次号获取异常');
        }
      });
    },
    deleteItem(item){
      const that=this;
      that.$confirm('是否确认移除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ButlerHttp.post("Litigation/deleteItem", {
          id: item.id
        }, res => {
          if (res.code) {
            that.getList();
          } else {
            that.$message.error(res.msg || "操作异常");
          }
        });
      });
    },
    exportExcel() {
      const that = this;
      if(!that.reginWhere.project_name){
        that.$message.error("请选择项目")
        return false
      }
      const loading=that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let where = {
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name
      }
      ButlerHttp.post("Litigation/exportExcel", {
        ...where
      }, res => {
        loading.close();
        if (res.code) {
          that.$refs.ViewFile.show({
            width: '90vw',
            height: '80vh',
            title: "文件预览",
            src: __HTTP__.defaults.baseURL + res.data,
            download() {
              window.open(__HTTP__.defaults.baseURL + res.data);
            }
          });
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    importExcel(){
      const that=this;
      Http.uploadFile(file=>{
        const loading=that.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        ButlerHttp.post("Litigation/importExcel", {
          file: file
        }, res => {
          loading.close();
          if (res.code) {
            that.pageChange(1);
            that.getAjaxCount();
          } else {
            that.$message.error(res.msg);
          }
        });
      })
    },
    selectRemove(){
      const that=this;
      if(that.select_ids.length===0){
        that.$message.error('请选择记录')
        return false
      }

      ButlerHttp.post("Litigation/deleteItem", {
        ids: that.select_ids.join(',')
      }, res => {
        if (res.code) {
          that.pageChange(1);
          that.getAjaxCount();
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    selectStartFlow(){
      const that = this;

      if(that.select_ids.length===0){
        that.$message.error('请选择记录')
        return false
      }

      ButlerHttp.post("Litigation/getBatchNumber", {
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name,
        ids: that.select_ids.join(',')
      }, res => {
        if (res.code) {
          let timeValue = new Date().getTime();
          // ERP.navigateTo("/flow/FlowView?sheet_id=66&master_id=63&batch_number=" + res.data + '&timeValue=' + timeValue);
          ERP.navigateTo("/flow/FlowView?sheet_id=210&master_id=174&batch_number=" + res.data + '&timeValue=' + timeValue);
        } else {
          that.$message.error(res.msg || '批次号获取异常');
        }
      });
    },
    exportLitigationEvidenceExcel(){
      const that = this;
      // if(!that.reginWhere.project_name){
      //   that.$message.error("请选择项目")
      //   return false
      // }
      const loading=that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let where = {
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name
      }
      ButlerHttp.post("Litigation/getLitigationEvidence", {
        ...where
      }, res => {
        loading.close();
        if (res.code) {
          that.$refs.ViewFile.show({
            width: '90vw',
            height: '80vh',
            title: "文件预览",
            src: __HTTP__.defaults.baseURL + res.data,
            download() {
              window.open(__HTTP__.defaults.baseURL + res.data);
            }
          });
        } else {
          that.$message.error(res.msg);
        }
      });
    }
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(()=>{
        that.pageChange(1)
        that.getAjaxCount()
      },500,that)
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(()=>{
        that.pageChange(1)
        that.getAjaxCount()
      },500,that)
    },
    "reginWhere.project_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(()=>{
        that.pageChange(1)
        that.getAjaxCount()
      },500,that)
    },
    "reginWhere.area_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(()=>{
        that.pageChange(1)
        that.getAjaxCount()
      },500,that)
    },
    "reginWhere.age":function (n,o) {
      const that=this;
      CommonHelp.debounce(()=>{
        that.pageChange(1)
        that.getAjaxCount()
      },500,that)
    },
    "where.text":function (n,o) {
      const that=this;
      CommonHelp.debounce(()=>{
        that.pageChange(1)
        that.getAjaxCount()
      },500,that)
    },
    "where.start_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(()=>{
        that.pageChange(1)
        that.getAjaxCount()
      },500,that)
    },
    "where.end_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(()=>{
        that.pageChange(1)
        that.getAjaxCount()
      },500,that)
    }
  },
  computed:{
    select_ids(){
      return this.multipleSelection.map(ret=>ret.id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";

.m-2{
  width: 150px;
}
.ti {
  margin: 1%;
  width: 98%;
}

.text1 {
  text-align: center;
}

.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}

.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}

.text2 {
  color: rgb(250, 248, 248);
}

.kuan {
  width: 10%;
}

.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
  margin: 30px;
  width: calc( 100% - 10px );
  overflow-y: scroll;
  height: calc( 100vh - 150px );

  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }

  .btn-item {
    margin-top: 10px;
    margin-right: 30px;
  }

  >>>.el-tabs__item{
    color: black;
  }
}
.view-file-win{
  height: 60vh;
  overflow-y: scroll;
  .main-log{
    margin: 10px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/litigation/LitigationTab1.vue